import { __assign, __rest } from "tslib";
import InternalBox from '../box/internal';
import styles from './styles.css.js';
import React, { useCallback } from 'react';
import InternalFormField from '../form-field/internal';
import InternalColumnLayout from '../column-layout/internal';
import { fireNonCancelableEvent } from '../internal/events';
import InternalGrid from '../grid/internal';
import { InternalButton } from '../button/internal';
var Divider = function () { return React.createElement(InternalBox, { className: styles.divider, padding: { top: 'l' } }); };
var Attribute = function (_a) {
    var control = _a.control, hideLabel = _a.hideLabel, props = __rest(_a, ["control", "hideLabel"]);
    return (React.createElement(InternalFormField, __assign({ __hideLabel: hideLabel }, props, { className: styles.field, stretch: true }), control));
};
var GRID_DEFINITION = [{ colspan: { "default": 12, xs: 9 } }];
var REMOVABLE_GRID_DEFINITION = [{ colspan: { "default": 12, xs: 9 } }, { colspan: { "default": 12, xs: 3 } }];
export var Row = React.memo(function (_a) {
    var breakpoint = _a.breakpoint, item = _a.item, definition = _a.definition, index = _a.index, removable = _a.removable, removeButtonText = _a.removeButtonText, removeButtonRefs = _a.removeButtonRefs, onRemoveButtonClick = _a.onRemoveButtonClick;
    var isNarrowViewport = breakpoint === 'default' || breakpoint === 'xxs';
    var isWideViewport = !isNarrowViewport;
    var handleRemoveClick = useCallback(function () {
        fireNonCancelableEvent(onRemoveButtonClick, { itemIndex: index });
    }, [onRemoveButtonClick, index]);
    var render = function (item, itemIndex, slot) {
        return typeof slot === 'function' ? slot(item, itemIndex) : slot;
    };
    return (React.createElement(InternalBox, { className: styles.row, margin: { bottom: 's' } },
        React.createElement(InternalGrid, { __breakpoint: breakpoint, gridDefinition: removable ? REMOVABLE_GRID_DEFINITION : GRID_DEFINITION },
            React.createElement(InternalColumnLayout, { className: styles['row-control'], columns: definition.length, __breakpoint: breakpoint }, definition.map(function (_a, defIndex) {
                var info = _a.info, label = _a.label, constraintText = _a.constraintText, errorText = _a.errorText, control = _a.control;
                return (React.createElement(Attribute, { key: defIndex, label: label, info: info, constraintText: constraintText && render(item, index, constraintText), errorText: errorText && render(item, index, errorText), control: control && render(item, index, control), hideLabel: isWideViewport && index > 0 }));
            })),
            removable && (React.createElement(ButtonContainer, { disablePaddings: isNarrowViewport || index > 0 },
                React.createElement(InternalButton, { className: styles['remove-button'], formAction: "none", ref: function (ref) {
                        removeButtonRefs[index] = ref !== null && ref !== void 0 ? ref : undefined;
                    }, onClick: handleRemoveClick }, removeButtonText)))),
        isNarrowViewport && React.createElement(Divider, null)));
});
var ButtonContainer = function (_a) {
    var disablePaddings = _a.disablePaddings, children = _a.children;
    return disablePaddings ? React.createElement(React.Fragment, null, children) : React.createElement("div", { className: styles['button-container'] }, children);
};
//# sourceMappingURL=row.js.map